import { useCallback } from "react";

import { useEvent } from "react-use";

import { useWaterlyAppStore } from "../stores";
import { getWindowFocusFromBrowser } from "../util/windowFocus.utils";

const WindowFocusProvider = () => {
  const setWindowFocus = useWaterlyAppStore((s) => s.setWindowFocus);

  const onFocusChange = useCallback(() => {
    const isWindowFocused = getWindowFocusFromBrowser();

    setWindowFocus(isWindowFocused);
  }, [setWindowFocus]);

  useEvent("focus", onFocusChange);
  useEvent("blur", onFocusChange);
  useEvent("visibilitychange", onFocusChange, document);

  return null;
};

export default WindowFocusProvider;
